module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-create-entity-button"
  }, [_c('ModalReveal', {
    ref: _vm.componentId
  }, [_c('button', {
    staticClass: "button success",
    attrs: {
      "slot": "trigger"
    },
    slot: "trigger"
  }, [_vm._v("Edit")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Action"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.action),
      expression: "item.action"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.action)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "action", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Title"), _c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.item._translatable.title,
      "label": "Title",
      "value": _vm.item.title
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.title),
      expression: "item.title"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "title", $event.target.value)
      }
    }
  })])], 1)]), _c('div', {
    staticClass: "column"
  }, [_c('label', [_vm._v("Slug"), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.slug),
      expression: "item.slug"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.slug)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "slug", $event.target.value)
      }
    }
  })]), _c('label', [_vm._v("Button label"), _c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.item._translatable.button_labels,
      "label": "Button Labels",
      "value": _vm.item.button_labels
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.item.button_labels),
      expression: "item.button_labels"
    }],
    staticClass: "input-group-field",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.item.button_labels)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.item, "button_labels", $event.target.value)
      }
    }
  })])], 1)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('TranslateField', {
    attrs: {
      "group": "entities",
      "field": _vm.item._translatable.content,
      "label": "Content",
      "value": _vm.item.content
    }
  }), _c('Editor', {
    model: {
      value: (_vm.item.content),
      callback: function($$v) {
        _vm.$set(_vm.item, "content", $$v)
      },
      expression: "item.content"
    }
  })], 1)]), _c('ActionButton', {
    attrs: {
      "slot": "footer",
      "action": _vm.update
    },
    slot: "footer"
  }, [_vm._v("Update")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5760dd9a!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/backoffice/EditPageReveal.vue
// module id = 2509
// module chunks = 1